import React from 'react';
import { StaticQuery, graphql } from 'gatsby';
import ScrollAnimation from 'react-animate-on-scroll';
import Masonry from 'react-masonry-css';
import { Card } from '../../UI/Card';
import { PlanCard } from './PlanCard';
import { getSafe } from '../../utils/getSafe';
import Button from '../../UI/Button';
import Title from '../../UI/Title';
import './Plans.scss';

export default function Plans({ fullData, ref, elianaPrice = false }) {
    const breakpointColumnsObj = {
        default: 3,
        900: 1,
    };
    const renderMoreButton = fullData => {
        return (
            !fullData && (
                <div className="button-div">
                    <Button to="/planes" text="Ver todos los planes" />
                </div>
            )
        );
    };

    /* Getting the info for Eliana page or no */
    const getTitle = (titulo, tituloEliana, elianaPrice) => {
        return elianaPrice ? tituloEliana : titulo;
    };
    return (
        <StaticQuery
            query={graphql`
                query {
                    allContentfulPlanes(
                        sort: { fields: [posicion, createdAt], order: ASC }
                        filter: { paquete: { ne: true }, otraCategoria: { ne: true } }
                    ) {
                        edges {
                            node {
                                posicion
                                precio
                                precioEliana
                                caracteristicas
                                paquete
                                titulo {
                                    titulo
                                }
                                subtitulo {
                                    subtitulo
                                }
                            }
                        }
                    }
                    paquetes: allContentfulPlanes(
                        sort: { fields: [posicion, createdAt], order: ASC }
                        filter: { paquete: { eq: true }, otraCategoria: { ne: true } }
                    ) {
                        edges {
                            node {
                                posicion
                                precio
                                precioEliana
                                caracteristicas
                                paquete

                                titulo {
                                    titulo
                                }
                                subtitulo {
                                    subtitulo
                                }
                            }
                        }
                    }
                    otros: allContentfulPlanes(
                        sort: { fields: [posicion, createdAt], order: ASC }
                        filter: { paquete: { ne: true }, otraCategoria: { eq: true } }
                    ) {
                        edges {
                            node {
                                posicion
                                precio
                                precioEliana
                                caracteristicas
                                paquete

                                titulo {
                                    titulo
                                }
                                subtitulo {
                                    subtitulo
                                }
                            }
                        }
                    }
                    contentfulPlanesPagina {
                        tituloPlanesPresenciales
                        tituloPlanesOtros
                        tituloPlanesPaquete
                        descripcionSeccion {
                            childMarkdownRemark {
                                html
                            }
                        }
                        descripcionSeccionEliana {
                            childMarkdownRemark {
                                html
                            }
                        }
                    }
                    contentfulInicioPagina {
                        tituloSeccionPlanes
                    }
                }
            `}
            render={data => {
                const planesPresenciales = getSafe(() => data.allContentfulPlanes, {});
                const section = getSafe(() => data.contentfulPlanesPagina, {});
                const titulo = getSafe(() => data.contentfulInicioPagina.tituloSeccionPlanes, 'Planes Sencillos');
                const tituloPlanesPresenciales = getSafe(() => section.tituloPlanesPresenciales);
                const tituloPaquetes = getSafe(() => section.tituloPlanesPaquete, 'Planes Paquetes');
                const tituloOtros = getSafe(() => section.tituloPlanesOtros, 'Otros');
                const descripcion = getSafe(() => section.descripcionSeccion.childMarkdownRemark.html);
                const descripcionEliana = getSafe(() => section.descripcionSeccionEliana.childMarkdownRemark.html);
                const paquetes = getSafe(() => data.paquetes, {});
                const otros = getSafe(() => data.otros, {});
                return (
                    <section className={`cfp-plans ${fullData ? 'gray' : ''}`} ref={ref}>
                        <div className="child cfp-container">
                            <Card
                                titulo={titulo}
                                descripcion={getTitle(descripcion, descripcionEliana, elianaPrice)}
                                fullData={fullData}
                            />
                            <Title text={tituloPlanesPresenciales} />
                            <Masonry
                                breakpointCols={breakpointColumnsObj}
                                className={`content-grid plan-grid ${fullData ? 'full' : ''}`}
                                columnClassName=""
                            >
                                {planesPresenciales &&
                                    planesPresenciales.edges.map((plan, i) => {
                                        return (
                                            <PlanCard
                                                {...plan.node}
                                                key={i}
                                                i={i}
                                                fullData={fullData}
                                                elianaPrice={elianaPrice}
                                            />
                                        );
                                    })}
                            </Masonry>
                            {paquetes && (
                                <>
                                    <Title text={tituloPaquetes} />
                                    <Masonry
                                        breakpointCols={breakpointColumnsObj}
                                        className={`content-grid plan-grid ${fullData ? 'full' : ''}`}
                                        columnClassName=""
                                    >
                                        {paquetes &&
                                            paquetes.edges.map((plan, i) => {
                                                return (
                                                    <PlanCard
                                                        {...plan.node}
                                                        key={i}
                                                        i={i}
                                                        fullData={fullData}
                                                        elianaPrice={elianaPrice}
                                                    />
                                                );
                                            })}
                                    </Masonry>
                                </>
                            )}
                            {otros && (
                                <>
                                    <Title text={tituloOtros} />
                                    <Masonry
                                        breakpointCols={breakpointColumnsObj}
                                        className={`content-grid plan-grid ${fullData ? 'full' : ''}`}
                                        columnClassName=""
                                    >
                                        {otros &&
                                            otros.edges.map((plan, i) => {
                                                return (
                                                    <PlanCard
                                                        {...plan.node}
                                                        key={i}
                                                        i={i}
                                                        fullData={fullData}
                                                        elianaPrice={elianaPrice}
                                                    />
                                                );
                                            })}
                                    </Masonry>
                                </>
                            )}
                            {renderMoreButton(fullData)}
                        </div>
                        {!fullData && (
                            <div className="rectangle-top-right">
                                <ScrollAnimation animateIn="slideInRight" animateOnce={true}>
                                    <img src="/rectangle.svg" alt="Rectangle" className="rectangle-img" />
                                </ScrollAnimation>
                            </div>
                        )}
                    </section>
                );
            }}
        />
    );
}
